import type { ProposalDetail } from '../../types/agent';

export function ContextPanel({ p }: { p: ProposalDetail }) {
  const snap = p.trigger_snapshot;
  return (
    <section className="border border-neutral-300 dark:border-neutral-700 p-4">
      <h3 className="font-semibold mb-2">Context</h3>
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt>Athlete</dt><dd>{p.athlete.name}</dd>
        <dt>Team</dt><dd>{p.team_name}</dd>
        <dt>Risk tier</dt>
        <dd>
          {snap.risk_before ?? '-'} -&gt; <strong>{snap.risk_after ?? '-'}</strong>
        </dd>
        <dt>Readiness</dt><dd>{snap.readiness_score ?? '-'}</dd>
      </dl>
    </section>
  );
}
